@if (isContentBlurred) {
  <div class="blur-overlay"></div>
}
<div
  id="data-window-container"
  class="wheel-table-right data-window-content scroll-style"
  appStickyPanelOffset
>
  <app-symbol-details-sticky-panel
    [watchListType]="watchlistTypes.Wheel"
    [smileyListType]="smileyListType.Wheel"
    [symbol]="currentSymbol$ | async"
    [elementsVisibilityConfig]="{ showExpectedMove: true, showAnalyzeEarningsBtn: false, showAddAlertBtn: true }"
    (symbolSelected)="onSelectSymbolFromDataWindow($event)"
    (openNews)="openNews.emit()"
  ></app-symbol-details-sticky-panel>
  <div
    [inViewportOptions]="{ threshold: [0], partial: true }"
    (inViewportAction)="onChangeVisibility($event, 'top')"
    class="top-indicator"
    inViewport
  ></div>

  <app-symbol-details-panel-v2
    [symbol]="currentSymbol$ | async"
    [elementsVisibilityConfig]="{ showExpectedMove: true, showAnalyzeEarningsBtn: false, showAddAlertBtn: true }"
    (symbolSelected)="onSelectSymbolFromDataWindow($event)"
    (lastTradedPriceUpdated)="onLastTradedPriceUpdate($event)"
    (openNews)="openNews.emit()"
  ></app-symbol-details-panel-v2>
  <ng-container>
    <app-expected-move
      [securityId]="currentSymbol$ | async"
      [showWheelChartSettings]="true"
      [liveDataIntervalSeconds]="30"
      [calculateLiveExpectedMoveFromOptions]="true"
      *appHideForUnavailableFeature="features.ExpectedMove; else expectedMovePlaceholder"
      class="expected-move-container"
    ></app-expected-move>

    <ng-template #expectedMovePlaceholder>
      <div class="expected-move-placeholder">
        <button
          (click)="redirectToExpectedMoveDemoPage()"
          mat-button
          class="expected-move-demo-button locked-for-current-edition"
        >
          Expected Move
        </button>
      </div>
    </ng-template>
  </ng-container>

  <app-income-statement [securityId]="currentSymbol$ | async"></app-income-statement>

  <mat-tab-group
    [selectedIndex]="selectedOptionTabIndex"
    (selectedIndexChange)="optionsTabChanged($event)"
    #optionsTabsGroup
    mat-stretch-tabs="false"
    animationDuration="0"
    disableRipple="true"
    class="pxo-tabs s-tabs options-tabs"
  >
    <mat-tab [label]="'sell-put'">
      <ng-template mat-tab-label>Sell Put</ng-template>
    </mat-tab>

    <mat-tab [label]="'sell-call'">
      <ng-template mat-tab-label>Sell Call</ng-template>
    </mat-tab>
  </mat-tab-group>

  @if (selectedOptionTabIndex === 0) {
    <div class="warnings"></div>

    <div class="settings">
      <mat-slide-toggle
        [checked]="wheelShowSellPutMinStrikeLine()"
        (change)="onShowSellPutMinStrikeLineChange($event.checked)"
        class="large-slide-toggle"
      >
        Show Low Strike on chart
      </mat-slide-toggle>
    </div>

    <div class="list-table weel-tables">
      @if (strikePrice.length > 0) {
        <div
          class="tableScroll scroll-data visible-scroll"
          id="standardScroll"
        >
          <table>
            <colgroup>
              <col span="1" />
              <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
              @for (group of colGroupsByDate; track i; let i = $index) {
                <col [span]="group" />
              }
            </colgroup>
            <tbody>
              <tr>
                <th>Strike Price, $</th>
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (strike of strikePrice; track i; let i = $index) {
                  <td class="strike">
                    <div class="strike-inner">
                      <span>{{ strike.value }}</span>
                      @if (sources[i]) {
                        <div
                          [matTooltip]="sourcesTooltipText[sources[i]]"
                          [ngClass]="{ conservative: sources[i] === 'C', aggressive: sources[i] === 'A' }"
                          class="option-source"
                        >
                          {{ sources[i] }}
                        </div>
                      }
                    </div>
                  </td>
                }
              </tr>
              <tr>
                <th>
                  <div>
                    Premium, $
                    <div class="center-in-tbl">
                      <span class="redText">Min</span>
                      <svg
                        [matTooltip]="'Minimum required premium to get 30% ROI'"
                        [matTooltipPosition]="'below'"
                        [matTooltipHideDelay]="0"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        class="help-icon-tbl"
                      >
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path
                          d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
                        />
                      </svg>
                    </div>
                  </div>
                </th>
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (premium of premium; track i; let i = $index) {
                  <td class="font-RB">
                    {{ premium.value | number: '1.2-2' }}
                    <p class="redText smallFont">
                      {{ premium.value1 ? (premium.value1 | number: '1.2-2') : 0.0 }}
                    </p>
                  </td>
                }
              </tr>
              <tr>
                <th>Expiration</th>
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (exp of expiration; track i; let i = $index) {
                  <td>{{ exp.value }}</td>
                }
              </tr>
              <tr>
                <th>Drop in %</th>
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (dr of drop; track i; let i = $index) {
                  <td class="font-blur">
                    {{ dr.value | number: '1.0-0' }}
                  </td>
                }
              </tr>
              <!--  commented code, do not remove, can be returned  -->
              <!--        <tr>-->
              <!--          <th>-->
              <!--            <div class="center-in-tbl">-->
              <!--              DTE, Days-->
              <!--              <svg-->
              <!--                xmlns="http://www.w3.org/2000/svg"-->
              <!--                [matTooltip]="'DTE - Days to expiration. The number of days until an option expires.'"-->
              <!--                viewBox="0 0 16 16"-->
              <!--                [matTooltipPosition]="'below'"-->
              <!--                [matTooltipHideDelay]="0"-->
              <!--                class="help-icon-tbl"-->
              <!--              >-->
              <!--                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />-->
              <!--                <path-->
              <!--                  d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"-->
              <!--                />-->
              <!--              </svg>-->
              <!--            </div>-->
              <!--          </th>-->
              <!--          <td class="font-blur" *ngFor="let dt of dte">-->
              <!--            {{ dt.value | number: '1.0-0' }}-->
              <!--          </td>-->
              <!--        </tr>-->
              <tr>
                <th>Buying Power, $</th>
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (bp of buyingPower; track i; let i = $index) {
                  <td class="font-blur">
                    {{ bp.value | number: '1.0-0' }}
                  </td>
                }
              </tr>
              <tr>
                <th>Delta</th>
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (bp of delta; track i; let i = $index) {
                  <td class="font-blur">
                    {{ bp.value ? (bp.value | number: '1.2-2') : 'n/a' }}
                  </td>
                }
              </tr>
              <tr>
                <th>
                  <div class="center-in-tbl">
                    ROI, %
                    <svg
                      [matTooltip]="roiLegend"
                      [matTooltipPosition]="'below'"
                      [matTooltipHideDelay]="0"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 16 16"
                      class="help-icon-tbl"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
                      />
                    </svg>
                  </div>
                </th>
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (ann of annularized; track i; let i = $index) {
                  <td>
                    <div
                      [ngClass]="{
                        'meet-box': ann.value >= roiLowerBound && ann.value <= roiUpperBound,
                        'does-not': !ann.value || ann.value < roiLowerBound,
                        warning: ann.value > roiUpperBound,
                      }"
                    >
                      {{ ann.value | number: '1.0-0' }}
                    </div>
                  </td>
                }
              </tr>
              @if (strikePrice.length > 0) {
                <tr>
                  <th></th>
                  <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                  @for (_ of strikePrice; track i; let i = $index) {
                    <td
                      (click)="onAddSellPutOption(i)"
                      class="plus-box"
                    >
                      <div class="center-plus">
                        <button
                          mat-button
                          class="calculator-plus-btn"
                        >
                          Add
                        </button>
                      </div>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      @if (strikePrice.length === 0) {
        <div class="no-options-wrapper">
          <div class="no-options">
            <p class="title">No options found because</p>
            <ul class="details list">
              <li>Symbol does not have weekly options or</li>
              <li>The earnings date is before the expiration date or</li>
              <li>The annualized ROI for the options is less than 5% or</li>
              <li>Any of your filter selection are filtering out the options</li>
            </ul>
          </div>
        </div>
      }

      <div
        [inViewportOptions]="{ threshold: [0], partial: true }"
        (inViewportAction)="onChangeVisibility($event, 'bottom')"
        class="bottom-indicator"
        inViewport
      ></div>
    </div>
  }

  @if (selectedOptionTabIndex === 1) {
    @let callOptionsTable = sellCallOptionsTable();

    <div class="warnings">
      <div class="alert alert-info">
        @if (callOptionsTable.priceMode === 'tradingLog') {
          Calculations are based on the Cost Basis of the selected trade from the Trading Log
        } @else {
          Calculations are based on the current stock price
        }
      </div>
    </div>

    <div class="settings">
      <mat-slide-toggle
        [checked]="wheelShowSellCallMinStrikeLine()"
        (change)="onShowSellCallMinStrikeLineChange($event.checked)"
        class="large-slide-toggle"
      >
        Show High Strike on chart
      </mat-slide-toggle>
    </div>

    <div class="list-table weel-tables">
      @if (callOptionsTable.table.strikePrice.length > 0) {
        <div
          class="tableScroll scroll-data visible-scroll"
          id="standardScroll"
        >
          <table>
            <colgroup>
              <col span="1" />
              <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
              @for (group of callOptionsTable.table.colGroupsByDate; track i; let i = $index) {
                <col [span]="group" />
              }
            </colgroup>
            <tbody>
              <tr>
                <th>Strike Price, $</th>
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (strike of callOptionsTable.table.strikePrice; track i; let i = $index) {
                  <td class="strike">
                    <div class="strike-inner">
                      <span>{{ strike.value }}</span>
                    </div>
                  </td>
                }
              </tr>
              <tr>
                <th>
                  <div>
                    Premium, $
                    <div class="center-in-tbl">
                      <span class="redText">Min</span>
                      <svg
                        [matTooltip]="'Minimum required premium to get 30% ROI'"
                        [matTooltipPosition]="'below'"
                        [matTooltipHideDelay]="0"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        class="help-icon-tbl"
                      >
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path
                          d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
                        />
                      </svg>
                    </div>
                  </div>
                </th>
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (premium of callOptionsTable.table.premium; track i; let i = $index) {
                  <td class="font-RB">
                    {{ premium.value | number: '1.2-2' }}
                    <p class="redText smallFont">
                      {{ premium.value1 ? (premium.value1 | number: '1.2-2') : 0.0 }}
                    </p>
                  </td>
                }
              </tr>
              <tr>
                <th>Expiration</th>
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (exp of callOptionsTable.table.expiration; track i; let i = $index) {
                  <td>{{ exp.value }}</td>
                }
              </tr>
              <tr>
                <th>Gain in %</th>
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (gn of callOptionsTable.table.gainPercent; track i; let i = $index) {
                  <td class="font-blur">
                    {{ gn.value | number: '1.0-0' }}
                  </td>
                }
              </tr>
              <tr>
                <th>Delta</th>
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (bp of callOptionsTable.table.delta; track i; let i = $index) {
                  <td class="font-blur">
                    {{ bp.value ? (bp.value | number: '1.2-2') : 'n/a' }}
                  </td>
                }
              </tr>
              <tr>
                <th>
                  <div class="center-in-tbl">
                    ROI, %
                    <svg
                      [matTooltip]="roiLegend"
                      [matTooltipPosition]="'below'"
                      [matTooltipHideDelay]="0"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 16 16"
                      class="help-icon-tbl"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
                      />
                    </svg>
                  </div>
                </th>
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (ann of callOptionsTable.table.annularized; track i; let i = $index) {
                  <td>
                    <div
                      [ngClass]="{
                        'meet-box': ann.value >= roiLowerBound && ann.value <= roiUpperBound,
                        'does-not': !ann.value || ann.value < roiLowerBound,
                        warning: ann.value > roiUpperBound,
                      }"
                    >
                      {{ ann.value | number: '1.0-0' }}
                    </div>
                  </td>
                }
              </tr>
              @if (callOptionsTable.table.strikePrice.length > 0) {
                <tr>
                  <th></th>
                  <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                  @for (_ of callOptionsTable.table.strikePrice; track i; let i = $index) {
                    <td
                      (click)="onAddSellCallOption(i)"
                      class="plus-box"
                    >
                      <div class="center-plus">
                        <button
                          mat-button
                          class="calculator-plus-btn"
                        >
                          Add
                        </button>
                      </div>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      @if (callOptionsTable.table.strikePrice.length === 0) {
        <div class="no-options-wrapper">
          <div class="no-options">
            <p class="title">No options found because</p>
            <ul class="details list">
              <li>Symbol does not have weekly options or</li>
              <li>The earnings date is before the expiration date or</li>
              <li>The annualized ROI for the options is less than 5% or</li>
              <li>Any of your filter selection are filtering out the options</li>
            </ul>
          </div>
        </div>
      }

      <div
        [inViewportOptions]="{ threshold: [0], partial: true }"
        (inViewportAction)="onChangeVisibility($event, 'bottom')"
        class="bottom-indicator"
        inViewport
      ></div>
    </div>
  }
</div>
